import { useState } from 'react';
import { Button, Flex, Logo, Page } from 'components';
import { FrameLogin, FrameRegister } from './components';
import './style.scss';

type PageState = 'login' | 'register';

function PageAuth() {
  const [state, updateState] = useState<PageState>('login');
  const title = state === 'login' ? 'Авторизация' : 'Регистрация';

  const switchState = () => {
    if (state === 'login') {
      updateState('register');
    } else if (state === 'register') {
      updateState('login');
    }
  };

  const switchButtonText = state === 'login' ? 'Создать аккаунт' : 'Уже есть аккаунт';

  return (
    <Page title={title}>
      <Flex gap={20}>
        <div className='pg-a-filler-zt33' />
        <Flex
          direction='column'
          alignItems='center'
          gap={40}
          className='auth-cnt-9hnu'
        >
          <Logo size={{ width: 150 }} />
          <Flex
            direction='column'
            gap={10}
          >
            {state === 'login' && <FrameLogin />}
            {state === 'register' && <FrameRegister />}
            <Button
              color='transparent-red'
              onClick={switchState}
              size='small'
            >
              {switchButtonText}
            </Button>
          </Flex>
        </Flex>
        <div className='pg-a-filler-zt33' />
      </Flex>
    </Page>
  );
}

export default PageAuth;
